module.exports = __webpack_public_path__ + "f153a554d468d2b8c113d1fd3b729b94.svg";